// @flow
import React, { useContext } from 'react'
import deStrings from './locales/de.yml'
import frStrings from './locales/fr.yml'
import { LocaleContext } from '../../context/locale'

/**
 * Display an error message, explaining why an article couldn't be loaded.
 * @param {{ locale: string | number; }} props
 */
export function FetchErrorMessage(props) {
  const locale = useContext(LocaleContext)

  const MESSAGES = {
    de: deStrings,
    fr: frStrings
  }

  const parseHTTPStatus = statusMessage => {
    const status =
      statusMessage.match(/^(\d{3}):.*$/) &&
      statusMessage.match(/^(\d{3}):.*$/)[1]
    if (status !== undefined) {
      return status
    }
  }

  return (
    <div className='ui error icon message'>
      <i className='icon'>🤖</i>
      <div className='content'>
        <div className='header'>{MESSAGES[locale].TITLE}</div>
        <p>
          {MESSAGES[locale][parseHTTPStatus(props.status)] ||
            MESSAGES[locale].DEFAULT}
        </p>
      </div>
    </div>
  )
}
